<template>
  <div class="tax-details container" v-if="organization">
    <TaxDetailsInfo
      :uploading="uploading"
      :organization="organization"
      @uploadTaxForm="uploadTaxForm"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import TaxDetailsInfo from './TaxDetailsInfo';

@Component({
  components: {
    TaxDetailsInfo,
  },
})
export default class TaxDetailsRoute extends Vue {
  uploading = false;

  get organization () {
    return this.$store.getters.currentOrganization;
  }

  get taxForm () {
    return this.organization.taxForm;
  }

  created () {
    this.$store.commit('setTitle', this.$t('Tax Details'));
  }

  async uploadTaxForm (file) {
    this.uploading = true;
    try {
      await this.$store.dispatch('uploadTaxForm', file);
      this.$store.commit('setFlash', {
        type: 'success',
        message: this.$t('Your Tax Form was successfully uploaded.'),
      });
    } finally {
      this.uploading = false;
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.tax-details {
  margin-top: var(--spacingMd);
}
</style>
